// extracted by mini-css-extract-plugin
export default {"modalWindow":"styles_modalWindow__R7qAM","modalWindow__mask":"styles_modalWindow__mask__Gz-Uw"};